// React
import React, { Component } from "react";
// Components
import {
  TextField,
  Tooltip,
  InputLabel,
  FormHelperText,
} from "@material-ui/core";
// Styles
import "../styles.scss";
// Svg
import { warningSvg } from "@assets";

export class Input extends Component {
  render() {
    const {
      id,
      value,
      placeholder,
      type,
      inputType,
      onChange,
      onKeyDown,
      onBlur,
      multiline,
      minRows,
      inputProps,
      warning,
      error,
      disabled,
      label,
      autocomplete,
      helper,
    } = this.props;
    return (
      <React.Fragment>
        <div className={"platform_input_content"}>
          {label && <InputLabel>{label}</InputLabel>}
          <TextField
            error={error}
            id={id}
            onChange={onChange}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            autoComplete={autocomplete}
            multiline={multiline}
            minRows={minRows}
            type={inputType ?? "text"}
            inputProps={inputProps ?? {}}
            disabled={disabled}
            className={`platform_input platform_input__${type ?? "primary"} ${
              error ? "b-error" : ""
            }`}
            placeholder={placeholder}
            value={value}
          />
          {warning && (
            <Tooltip
              title={warning}
              placement="bottom"
              enterDelay={500}
              leaveDelay={300}
            >
              <span className={"platform_input_warning"}>{warningSvg()}</span>
            </Tooltip>
          )}
          {helper && <FormHelperText>{helper}</FormHelperText>}
        </div>
      </React.Fragment>
    );
  }
}
